var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.25H18",
    stroke: "black",
    strokeWidth: 1.2973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54051 6.57422H4.81078C3.85548 6.57422 3.08105 7.34865 3.08105 8.30395V13.4931C3.08105 14.4484 3.85548 15.2229 4.81078 15.2229H6.54051C7.49582 15.2229 8.27024 14.4484 8.27024 13.4931V8.30395C8.27024 7.34865 7.49582 6.57422 6.54051 6.57422Z",
    stroke: "black",
    strokeWidth: 1.2973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.189 2.25H13.4592C12.5039 2.25 11.7295 3.02443 11.7295 3.97973V13.4932C11.7295 14.4485 12.5039 15.223 13.4592 15.223H15.189C16.1443 15.223 16.9187 14.4485 16.9187 13.4932V3.97973C16.9187 3.02443 16.1443 2.25 15.189 2.25Z",
    stroke: "black",
    strokeWidth: 1.2973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.c746d0db5de0be329538dca891a66b01.svg";
export { ForwardRef as ReactComponent };